var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { busService } from "../bus";
import { Box3, Sphere } from "flavr-math";
class MeshBoundingPromise {
    constructor() {
        this.resolve = () => { };
        this.reject = () => { };
        this.isLoaded = false;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.promise.then((bounding) => {
            this.bounding = bounding;
            this.isLoaded = true;
        }).catch(e => { console.error(e); });
    }
    wait() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.promise;
        });
    }
}
class MeshBoundingService {
    constructor() {
        this.connection = busService.connection("MeshBoundingService");
        this.meshData = new Map();
        this.numWaitingBounds = 0;
    }
    /// Getters ///
    hasBounding(meshUrl) {
        return this.meshData.has(meshUrl);
    }
    getBounding(meshUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const boundingPromise = this.getOrCreatePromise(meshUrl);
            return boundingPromise.bounding;
        });
    }
    getBoundingOnceFinished(meshUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const boundingPromise = this.getOrCreatePromise(meshUrl);
            if (boundingPromise.isLoaded)
                return boundingPromise.bounding;
            return yield boundingPromise.wait();
        });
    }
    getBoundingDataPromise(meshUrl) {
        return this.getOrCreatePromise(meshUrl);
    }
    /// Bounds helper methods ///
    generateFullMeshUrl(meshName, pieceName) {
        return (pieceName === undefined) ? meshName : `${meshName}@${pieceName}`;
    }
    updateBounding(meshUrl, boundingBox, boundingSphere) {
        let meshBoundingPromise = this.meshData.get(meshUrl);
        if (meshBoundingPromise === undefined) {
            meshBoundingPromise = new MeshBoundingPromise();
            this.meshData.set(meshUrl, meshBoundingPromise);
        }
        const bounding = {
            boundingBox: new Box3().copy(boundingBox),
            boundingSphere: new Sphere().copy(boundingSphere)
        };
        meshBoundingPromise.resolve(bounding);
        if (this.numWaitingBounds > 0) {
            this.numWaitingBounds--;
            if (this.numWaitingBounds === 0) {
                console.debug("[mesh] All boundaries were loaded");
            }
        }
    }
    /// Private promise helper methods ///
    getOrCreatePromise(meshUrl) {
        let deferred = this.meshData.get(meshUrl);
        if (deferred === undefined) {
            deferred = new MeshBoundingPromise();
            this.meshData.set(meshUrl, deferred);
            this.numWaitingBounds++;
        }
        return deferred;
    }
}
export const meshBoundingService = new MeshBoundingService();
